import { throttle } from 'lodash';
import { DOM, matchMediaMax, breakpoints } from '../const';

const { $hbody, $window } = DOM;

const $$scrollBtns = $('.js-scroll-down-btn');

const scrollBtn = () => {
    if ($window) {
        $$scrollBtns.each((i, el) => {
            const $parent = $(el).closest('.js-section');
            const $target = $parent.next('.js-section');
            if ($target.length > 0) {
                $(el).click(event => {
                    event.preventDefault();
                    if ($target.length) {
                        $hbody.animate({
                            scrollTop: $target.offset().top
                        }, 1000);
                    }
                });


                const watchScrollDownBtn = () => {
                    const menuHeight = matchMediaMax(breakpoints.sm - 1) ? 45 : 0;

                    if ($window.scrollTop() > $target.offset().top - $window.height() + menuHeight) {
                        $(el).addClass('is-invisible');
                    } else {
                        $(el).removeClass('is-invisible');
                    }
                };


                $window.scroll(throttle(watchScrollDownBtn, 200));
            }

        });
    }
};

export default scrollBtn;
